import React from 'react'
import { withStyles, createTheme, makeStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import StepConnector from '@material-ui/core/StepConnector'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import CircleChecked from '@material-ui/icons/CheckCircleOutline'
import SliderArrowButton from '~/components/Shared/SliderArrowButton'
import i18n from '~/i18n'

export const WhiteRadioButton = withStyles({
  root: {
    color: 'var(--input-title)',
    paddingLeft: '0px',
    marginLeft: '10px',
    '&$checked': {
      color: 'var(--input-title)',
    },
  },
  checked: {},
  disabled: {
    color: 'var(--input-title)',
    paddingLeft: '0px',
    marginLeft: '10px',
    '&$checked': {
      color: 'var(--input-title)',
    },
  },
})(props => <Checkbox color="default" icon={<CircleUnchecked />} checkedIcon={<CircleChecked />} disabled {...props} />)

export const stepperStyle = {
  borderRadius: '5px',
  fontFamily: 'Roboto',
  height: '100%',
  backgroundColor: 'transparent',
}

export const inputTheme = createTheme({
  overrides: {
    MuiFormControl: {
      root: {
        backgroundColor: '#FFF',
      },
    },
    MuiOutlinedInput: {
      root: {
        height: '38px',
      },
      multiline: {
        height: '120px',
      },
      disabled: {
        backgroundColor: '#e6e6e6',
      },
    },
  },
})

export const StepConnectorStyles = withStyles({
  active: {
    '& $line': {
      height: 5,
      border: 0,
      backgroundColor: '#F74657',
      borderRadius: 1,
      marginRight: '-9px',
      marginLeft: '-9px',
    },
  },
  completed: {
    '& $line': {
      height: 5,
      border: 0,
      backgroundColor: '#F74657',
      borderRadius: 1,
      marginRight: '-9px',
      marginLeft: '-9px',
    },
  },
  line: {},
})(StepConnector)

export const useStepStyles = makeStyles(() => ({
  root: {
    width: '250px',
    borderRadius: '5px',
    zIndex: 10,
    '& $active': {
      color: '#F74657',
      transform: 'scale(1.4)',
      fontWeight: 'bold',
      opacity: '1.0',
    },
    '& $completed': {
      color: '#F74657',
      opacity: '1.0',
    },
  },
  stepIcon: {
    opacity: '0.9',
  },
  active: {},
  completed: {},
  alternativeLabel: {},
  labelContainer: {
    '& $labelContainer': {
      fontSize: '13px',
    },
  },
}))

export const reactSelectStyleDefault = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? 0 : 0,
    borderRadius: '5px',
    fontSize: '16px !important',
    borderColor: state.isFocused ? '#50A5D2' : 'rgba(0, 0, 0, 0.26)',
    borderWidth: state.isFocused ? '1px' : '1px',
    backgroundColor: state.isDisabled ? '#e6e6e6' : '#FFF',
    color: state.isDisabled ? 'rgba(0, 0, 0, 0.30)' : base.color,
    '&:hover': {
      borderColor: state.isFocused ? '#50A5D2' : base.borderColor,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 999,
  }),
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: '#858588',
      fontSize: '15px',
      fontFamily: 'Roboto',
      opacity: '0.5',
      width: '100%',
    }
  },
  singleValue: provided => {
    const overflow = 'visible'
    const fontStyle = 'normal'
    const transition = 'opacity 300ms'

    return { ...provided, overflow, fontStyle, transition }
  },
}

export const reactTabSelectorStyle = {
  control: (base, state) => ({
    ...base,
    width: '120px',
    borderRadius: '100px',
    padding: '0px 5px',
    boxShadow: '0px 2px 5px 2px rgba(240, 245, 254, 1)',
    border: 'none',
    backgroundColor: state.isDisabled ? '#FFF' : base.backgroundColor,
    color: state.isDisabled ? 'rgba(0, 0, 0, 0.30)' : base.color,
    '&:hover': {
      borderColor: state.isFocused ? '#50A5D2' : base.borderColor,
    },
  }),
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: '#858588',
      fontSize: '15px',
      fontFamily: 'Roboto',
      opacity: '0.5',
    }
  },
  singleValue: provided => {
    const overflow = 'visible'
    const fontStyle = 'normal'
    const transition = 'opacity 300ms'
    const color = '#5A6978'

    return { ...provided, overflow, fontStyle, color, transition }
  },
}

export function SampleNextArrow(props) {
  const { onClick } = props
  return (
    <SliderArrowButton
      direction="right"
      style={{ top: 'calc(50% - 16px)', right: '-22px', position: 'absolute' }}
      onClick={onClick}
    />
  )
}

export function SamplePrevArrow(props) {
  const { onClick } = props
  return (
    <SliderArrowButton
      direction="left"
      style={{ top: 'calc(50% - 16px)', left: '-25px', position: 'absolute', zIndex: '2' }}
      onClick={onClick}
    />
  )
}

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const settingsSliderCommunities = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  initialSlide: 0,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
}

export const surveyAnalyticsChartOptions = {
  responsive: false,
  maintainAspectRatio: false,
  plugins: {
    labels: {
      render: 'percentage',
      fontSize: 14,
      fontStyle: 'bold',
      fontColor: '#FFF',
    },
  },
  legend: {
    labels: {
      render: 'percentage',
      padding: 20,
      fontSize: 16,
      fontColor: '#222432',
      fontFamily: 'Roboto',
      width: 50,
    },
    position: 'bottom',
    reverse: false,
  },
}

export const pizzaChartDefaultOptions = {
  responsive: true,
  plugins: {
    labels: {
      render: 'percentage',
      fontSize: 14,
      fontStyle: 'bold',
      fontColor: '#FFF',
    },
  },
  legend: {
    labels: {
      render: 'percentage',
      padding: 20,
      fontSize: 16,
      fontColor: '#222432',
      fontFamily: 'Roboto',
    },
    position: 'bottom',
    reverse: false,
  },
}

export const modalBodyStyleDefault = {
  backgroundColor: '#F2F2F2',
  padding: '30px 30px',
  position: 'relative',
}

export const languages = [
  { id: 1, name: 'it', src: '/italy-flag.svg' },
  { id: 2, name: 'pt', src: '/brazil-flag.svg' },
  { id: 3, name: 'en', src: '/usa-flag.svg' },
]

export const chartDefaultOptions = {
  legend: {
    display: false,
  },
}

export const campaignFormatStatus = {
  waiting: i18n.t('waitingCommunityApproval'),
  running: i18n.t('running'),
  revision: i18n.t('revisionNeeded'),
  finalized: i18n.t('finalized'),
}

export const numberOfSurveyQuestionsOptions = [
  { value: 1, label: `1 ${i18n.t('question')}` },
  { value: 2, label: `2 ${i18n.t('questions')}` },
  { value: 3, label: `3 ${i18n.t('questions')}` },
  { value: 4, label: `4 ${i18n.t('questions')}` },
  { value: 5, label: `5 ${i18n.t('questions')}` },
]

export const couponTypeOptions = [
  { value: 1, label: i18n.t('no') },
  { value: 2, label: i18n.t('couponReusable') },
  { value: 3, label: i18n.t('couponBurnable') },
]

export const modalSponsoredDefault = {
  backgroundColor: '#F2F2F2',
  padding: '20px 30px',
  position: 'relative',
}

export const contentAvailable = [
  { value: 1, label: i18n.t('web') },
  { value: 2, label: i18n.t('post') },
  { value: 3, label: i18n.t('video') },
  // { value: 4, label: i18n.t('document') },
]

export const sponsorCampaignReviewPageTooltipOptions = [
  {
    target: '.campaignMockedPage',
    disableBeacon: 'true',
    placement: 'left-start',
  },
]

export const packagesMock = [
  {
    id: 1,
    description: `${i18n.t('package')} 1`,
    hasSpecialOffer: 1,
    monthlyPrice: '4500.00',
    name: `${i18n.t('package')} 1`,
    specialOfferDiscount: '40.00',
    specialOfferPrice: '2000.00',
  },
  {
    id: 2,
    description: `${i18n.t('package')} 2`,
    hasSpecialOffer: 0,
    monthlyPrice: '1000.00',
    name: `${i18n.t('package')} 2`,
    specialOfferDiscount: '20.00',
    specialOfferPrice: '800.00',
  },
]

export const communityInterestsMocked = [
  { id: 1, name: 'Artificial Intelligence', membersFollowPercentage: 20 },
  { id: 2, name: 'Database', membersFollowPercentage: 8 },
  { id: 3, name: 'Monetization', membersFollowPercentage: 12 },
  { id: 4, name: 'Marketing', membersFollowPercentage: 10 },
  { id: 5, name: 'Games', membersFollowPercentage: 15 },
  { id: 6, name: 'Digital', membersFollowPercentage: 35 },
]

export const productsMock = [
  { id: 1, name: i18n.t('survey') },
  { id: 2, name: i18n.t('event') },
  { id: 3, name: i18n.t('chatChannel') },
  { id: 4, name: i18n.t('mobileBoost') },
  { id: 5, name: i18n.t('content') },
  { id: 6, name: i18n.t('reward') },
  { id: 7, name: i18n.t('welcomeAd') },
]

export const sponsorCommunitiesTooltipOptions = [
  {
    target: '.communitiesTab',
    disableBeacon: 'true',
    placement: 'bottom-start',
  },
]

export const sponsorCampaignsTooltipOptions = [
  {
    target: '.startCampaignButton',
    disableBeacon: 'true',
    placement: 'right-start',
  },
]

export const sponsorCreateCampaignModalTooltipOptions = [
  {
    target: '.createCampaignModal',
    disableBeacon: 'true',
    placement: 'auto',
  },
]

export const communityFormatsTooltipOptions = [
  {
    target: '.communityFormatTab',
    disableBeacon: 'true',
    placement: 'bottom-start',
  },
]

export const communityPackagesTooltipOptions = [
  {
    target: '.communityPackageTab',
    disableBeacon: 'true',
    placement: 'bottom-start',
  },
]

export const communityStripeTooltipOptions = [
  {
    target: '.stripe-section',
    disableBeacon: 'true',
    placement: 'bottom-start',
  },
]

export const communitySponsorsTooltipOptions = [
  {
    target: '.communitySponsorTab',
    disableBeacon: 'true',
    placement: 'bottom-start',
  },
]

export const modalRatingStyle = {
  backgroundColor: '#F2F2F2',
  position: 'relative',
}

export const customModalBodyStyle = {
  backgroundColor: '#F2F2F2',
  paddingBottom: '60px',
  position: 'relative',
}

export const customNoiticeModalBodyStyle = {
  backgroundColor: '#F2F2F2',
  paddingBottom: '30px',
  position: 'relative',
}

export const campaignModalStyle = {
  backgroundColor: '#F2F2F2',
  padding: '10px 20px 26px 20px',
  position: 'relative',
}

export const privacyPolicyLink = 'https://privacy-policy-sandbox.hashtag.be/'

export const termsOfServiceLink = 'https://code-of-conduct-sandbox.hashtag.be/'

export const hashtagBeLink = 'https://hashtagbe.abilitya.tech/'

export const campaignModelSelectOptions = [
  { value: 1, label: i18n.t('sponsoredPackages') },
  { value: 2, label: i18n.t('payAsYouGoSelect') },
]

export const campaignModelSelectOptionsNoPackages = [{ value: 1, label: 'Pay-as-you-go' }]

export const numberOfMembersOptions = [
  { value: 1, label: `1-10 ${i18n.t('membersSelect')}` },
  { value: 2, label: `10-50 ${i18n.t('membersSelect')}` },
  { value: 3, label: `50+ ${i18n.t('membersSelect')}` },
]

export const messageType = {
  Joined: 'Joined',
  Message: 'Message',
  File: 'File',
  Video: 'Video',
  Image: 'Image',
  Link: 'Link',
  Content: 'HubContent',
  QuickfeedbackImage: 'qf-images',
  QuickfeedbackYesNo: 'qf-yes-no',
  QuickfeedbackReactions: 'qf-reactions',
  QuickfeedbackVideos: 'qf-videos',
  QuickfeedbackTextual: 'qf-textual',
  HubContent: 'HubContent',
  Voice: 'Voice',
  Gif: 'Gif',
}

export const currencyOptions = [
  { value: 1, label: `EUR`, slug: 'eur' },
  { value: 2, label: `USD`, slug: 'usd' },
  { value: 3, label: `BRL`, slug: 'brl' },
]

export const genderOptions = [
  { value: 0, label: i18n.t('unknown') },
  { value: 1, label: i18n.t('male') },
  { value: 2, label: i18n.t('female') },
  { value: 3, label: i18n.t('other') },
]

export const campaignDurationOptions = [
  { value: 1, label: `1 ${i18n.t('month')}` },
  { value: 2, label: `2 ${i18n.t('months')}` },
  { value: 3, label: `3 ${i18n.t('months')}` },
  { value: 4, label: `4 ${i18n.t('months')}` },
  { value: 5, label: `5 ${i18n.t('months')}` },
  { value: 6, label: `6 ${i18n.t('months')}` },
  { value: 7, label: `7 ${i18n.t('months')}` },
  { value: 8, label: `8 ${i18n.t('months')}` },
  { value: 9, label: `9 ${i18n.t('months')}` },
  { value: 10, label: `10 ${i18n.t('months')}` },
  { value: 11, label: `11 ${i18n.t('months')}` },
  { value: 12, label: `12 ${i18n.t('months')}` },
]

export const campaignDurationOptionsMocked = [{ value: 1, label: `1 ${i18n.t('month')}` }]

export const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'it', label: 'Italiano' },
  { value: 'pt', label: 'Portuguese' },
]

export const privacyOptions = [
  { value: 'public', label: i18n.t('public') },
  { value: 'unlisted', label: i18n.t('unlisted') },
]

export const base64DefaultBanner =
  'data:image/jpeg;base64,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'

export const settingsSliderMedias = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  initialSlide: 0,
  vertical: true,
  verticalSwiping: false,
}
